const colors = [
  '#00a66f',
  '#09c',
  '#ffbf00',
  '#f43',
];

export default () => colors[Math.floor(Math.random() * colors.length)];
